var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z"}));
}

Pause.defaultProps = {"height":"1792","viewBox":"0 0 1792 1792","width":"1792"};

module.exports = Pause;

Pause.default = Pause;
